// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cargotransportationcompmany() {



const cardData = {


    keyword: "Cargo Transportation Company in Pune",

    headingDescription: "SSK Logistic is a cargo transportation company in Pune supporting businesses with organized freight movement, commercial cargo handling, industrial transportation, container movement, full truck load requirements, ODC consignments, and route-based logistics coordination. Cargo transportation requires dependable planning across loading points, transit routes, warehouses, industrial facilities, distribution centers, and final destinations, particularly when shipments involve large volumes, heavy materials, or time-sensitive commercial requirements. SSK Logistic provides practical cargo transportation support for businesses looking to move goods across Pune, Maharashtra, and major destinations throughout India. From road cargo transportation and cargo booking to industrial freight movement and specialized consignments, the service approach focuses on coordinated transportation, suitable vehicle planning, route management, and structured delivery support.",

    topPlaces: [
        {
            title: "Daund",
            description: "Daund is an important transportation-linked location in the Pune region where businesses may require regular movement of commercial and industrial cargo. SSK Logistic supports cargo transportation requirements connecting Daund with manufacturing facilities, warehouses, suppliers, distributors, and other destination markets."
        },
        {
            title: "Pune to Chandigarh",
            description: "Pune to Chandigarh is a long-distance cargo corridor connecting western India with the northern commercial network. SSK Logistic assists businesses with planned road transportation for industrial materials, commercial consignments, packaged goods, and other cargo requiring organized interstate movement."
        },
        {
            title: "Kurkumbh",
            description: "Kurkumbh is associated with industrial activity and therefore can generate regular requirements for movement of materials, equipment, and finished goods. SSK Logistic provides cargo transportation coordination for businesses requiring planned movement between industrial locations, warehouses, and destination facilities."
        },
        {
            title: "Pune to Vijayawada",
            description: "The Pune to Vijayawada route connects businesses in Maharashtra with important markets in Andhra Pradesh. SSK Logistic supports cargo movement along this corridor through organized freight transportation planning for commercial and industrial consignments."
        },
        {
            title: "Katraj",
            description: "Katraj provides connectivity between several parts of Pune and major road networks, making it relevant for local and regional cargo movement. SSK Logistic helps businesses coordinate transportation from Katraj-based operations to warehouses, commercial destinations, and wider distribution routes."
        },
        {
            title: "Pune to Kochi",
            description: "Pune to Kochi is a significant long-distance route for businesses distributing products and industrial goods toward southern markets. SSK Logistic provides transportation coordination for cargo requiring structured interstate movement between Pune facilities and Kochi-area destinations."
        },
        {
            title: "Sanaswadi",
            description: "Sanaswadi is located along an important eastern Pune transportation belt and supports commercial and industrial activity. Cargo transportation from this area may involve supplier movements, factory dispatches, warehouse transfers, and regional distribution, which SSK Logistic can coordinate according to business requirements."
        },
        {
            title: "Pune to Jodhpur",
            description: "Pune to Jodhpur connects western India's commercial network with Rajasthan and surrounding markets. SSK Logistic supports businesses requiring road cargo transportation for commercial products, industrial materials, and other consignments moving over long distances."
        },
        {
            title: "Narhe",
            description: "Narhe is part of Pune's expanding commercial surroundings and can involve regular goods movement between business facilities and connected areas. SSK Logistic assists with cargo transportation planning for local, regional, and interstate requirements originating from or passing through the Narhe area."
        },
        {
            title: "Pune to Noida",
            description: "Pune to Noida provides an important connection between Maharashtra and the National Capital Region's commercial network. SSK Logistic supports businesses with organized cargo transportation for industrial goods, commercial shipments, distribution consignments, and recurring freight requirements along this route."
        }
    ],

    "services": [
        {
            "name": "cargo transportation company pune",
            "description": "Businesses searching for a cargo transportation company pune can use SSK Logistic for planned movement of commercial, industrial, and general cargo. Transportation support covers route coordination, vehicle planning, loading-point movement, interstate freight requirements, and delivery scheduling based on the shipment."
        },
        {
            "name": "cargo transport company pune",
            "description": "SSK Logistic operates cargo transportation support for businesses requiring dependable movement of goods from Pune to regional and national destinations. Cargo transport company pune requirements can include regular commercial dispatches, industrial shipments, warehouse transfers, and route-based freight movement."
        },
        {
            "name": "cargo transportation services pune",
            "description": "Cargo transportation services pune are designed for businesses that need organized movement of goods between suppliers, factories, warehouses, distribution centers, and customers. SSK Logistic coordinates transportation according to cargo type, route, volume, destination, and scheduling requirements."
        },
        {
            "name": "cargo transport services pune",
            "description": "SSK Logistic provides cargo transport services pune for commercial and industrial businesses managing different types of freight. The service can support local, regional, and interstate cargo movement with practical route planning and transportation coordination from pickup through delivery."
        },
        {
            "name": "cargo transporters pune",
            "description": "Businesses searching for cargo transporters pune can connect with SSK Logistic for structured transportation support covering commercial consignments, industrial materials, full-load requirements, and distribution cargo. Movement is coordinated around origin, destination, cargo characteristics, and required delivery schedules."
        },
        {
            "name": "cargo logistics company pune",
            "description": "As a cargo logistics company pune, SSK Logistic supports businesses with transportation coordination and freight movement across multiple locations. Services can connect cargo pickup points with warehouses, industrial facilities, distribution centers, and final destinations through planned road logistics."
        },
        {
            "name": "cargo logistics services pune",
            "description": "Cargo logistics services pune involve more than vehicle movement and may require coordination between pickup, transportation, warehouse transfer, distribution, and delivery stages. SSK Logistic assists businesses with organized cargo logistics based on shipment size, route, frequency, and destination requirements."
        },
        {
            "name": "freight cargo transportation pune",
            "description": "Freight cargo transportation pune supports businesses moving larger commercial and industrial consignments across regional and interstate routes. SSK Logistic coordinates road freight requirements with practical planning for vehicle capacity, cargo characteristics, route distance, and delivery points."
        },
        {
            "name": "industrial cargo transport pune",
            "description": "Industrial cargo transport pune requires careful coordination for raw materials, production supplies, machinery, components, and finished industrial goods. SSK Logistic supports industrial businesses with planned transportation between factories, suppliers, warehouses, project locations, and destination markets."
        },
        {
            "name": "commercial cargo transportation pune",
            "description": "Commercial cargo transportation pune helps retailers, distributors, wholesalers, and other businesses move products between suppliers, storage facilities, markets, and customers. SSK Logistic provides organized transportation support for recurring commercial cargo and distribution requirements."
        },
        {
            "name": "heavy cargo transport pune",
            "description": "Heavy cargo transport pune involves transportation planning for consignments that require suitable vehicle capacity and careful route coordination. SSK Logistic supports businesses moving heavy industrial materials, equipment, machinery, and other substantial cargo according to transportation requirements."
        },
        {
            "name": "high value cargo transportation pune",
            "description": "High value cargo transportation pune requires additional attention to transportation planning, handling procedures, route coordination, and delivery scheduling. SSK Logistic supports businesses moving valuable commercial or industrial consignments with a structured approach to cargo transportation and movement monitoring."
        },
        {
            "name": "container cargo transport pune",
            "description": "Container cargo transport pune supports businesses that need goods moved in containerized loads between industrial locations, warehouses, distribution points, and destination markets. SSK Logistic coordinates road transportation requirements for container cargo according to route and shipment specifications."
        },
        {
            "name": "road cargo transportation pune",
            "description": "Road cargo transportation pune provides a practical option for moving goods between Pune and destinations across Maharashtra and India. SSK Logistic assists with route planning, vehicle coordination, pickup arrangements, and delivery movement for commercial and industrial cargo."
        },
        {
            "name": "full truck load cargo transport pune",
            "description": "Full truck load cargo transport pune is suitable for businesses requiring dedicated vehicle capacity for larger consignments. SSK Logistic supports FTL cargo movement by coordinating suitable transportation, direct route planning, pickup schedules, and destination delivery requirements."
        },
        {
            "name": "ODC cargo transportation pune",
            "description": "ODC cargo transportation pune requires specialized planning when consignments exceed standard dimensions or involve unusual loading requirements. SSK Logistic assists businesses with transportation coordination for oversized and project-related cargo, including route considerations and suitable vehicle planning."
        },
        {
            "name": "safe cargo transportation pune",
            "description": "Safe cargo transportation pune is important when businesses need their goods moved with appropriate attention to handling, loading, transit planning, and delivery coordination. SSK Logistic follows an organized transportation approach designed around the requirements of each cargo movement."
        },
        {
            "name": "secure cargo transport pune",
            "description": "Secure cargo transport pune supports businesses that want organized movement of commercial and industrial goods from pickup to destination. SSK Logistic coordinates cargo transportation with attention to planned routes, handling requirements, vehicle suitability, and delivery scheduling."
        },
        {
            "name": "reliable cargo transportation pune",
            "description": "Reliable cargo transportation pune is valuable for businesses managing recurring dispatches and destination commitments. SSK Logistic provides structured transportation coordination for regular and project-based cargo movement across Pune, Maharashtra, and interstate routes."
        },
        {
            "name": "professional cargo transport pune",
            "description": "Professional cargo transport pune requires practical coordination between shipment details, vehicle requirements, pickup locations, transit routes, and final destinations. SSK Logistic supports businesses with organized cargo movement for commercial, industrial, and distribution requirements."
        },
        {
            "name": "cargo transport service provider pune",
            "description": "A cargo transport service provider pune can assist businesses with recurring freight movement and destination-based transportation requirements. SSK Logistic coordinates cargo transportation for businesses needing local, regional, and interstate road movement with suitable planning for each shipment."
        },
        {
            "name": "cargo booking service pune",
            "description": "Cargo booking service pune helps businesses arrange transportation for consignments according to cargo type, quantity, route, and destination. SSK Logistic supports booking and transportation coordination for commercial and industrial shipments requiring planned movement from Pune."
        },
        {
            "name": "cargo transportation company near pune",
            "description": "Businesses searching for a cargo transportation company near pune can use SSK Logistic for cargo movement connected with Pune's surrounding commercial and industrial areas. Transportation support can cover pickup coordination, regional distribution, interstate freight, and destination delivery requirements."
        },
        {
            "name": "cargo logistics provider pune",
            "description": "SSK Logistic serves as a cargo logistics provider pune for businesses requiring coordinated road transportation and freight movement. The service supports cargo transfer between suppliers, factories, warehouses, distributors, and destination markets while accommodating different shipment sizes and routes."
        },
        {
            "name": "cargo freight services pune",
            "description": "Cargo freight services pune support businesses that need organized movement of commercial and industrial consignments across different destinations. SSK Logistic coordinates freight transportation according to cargo volume, route distance, vehicle requirements, pickup schedules, and delivery locations."
        }
    ],

    "tableData": [
        ["cargo transportation company pune", "cargo transport company pune"],
        ["cargo transportation services pune", "cargo transport services pune"],
        ["cargo transporters pune", "cargo logistics company pune"],
        ["cargo logistics services pune", "freight cargo transportation pune"],
        ["industrial cargo transport pune", "commercial cargo transportation pune"],
        ["heavy cargo transport pune", "high value cargo transportation pune"],
        ["container cargo transport pune", "road cargo transportation pune"],
        ["full truck load cargo transport pune", "ODC cargo transportation pune"],
        ["safe cargo transportation pune", "secure cargo transport pune"],
        ["reliable cargo transportation pune", "professional cargo transport pune"],
        ["cargo transport service provider pune", "cargo booking service pune"],
        ["cargo transportation company near pune", "cargo logistics provider pune"],
        ["cargo freight services pune", "Cargo Transportation Company in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Organized Cargo Movement",
            WhyChoosedescription: "SSK Logistic focuses on coordinating cargo movement from pickup locations to final destinations through structured transportation planning. Shipment requirements are considered around cargo type, route, vehicle capacity, loading points, and delivery schedules."
        },
        {
            WhyChooseheading: "Industrial Freight Capability",
            WhyChoosedescription: "Industrial businesses may need transportation for raw materials, machinery, production supplies, components, and finished goods. SSK Logistic supports these cargo requirements with transportation coordination designed around industrial movement patterns and destination networks."
        },
        {
            WhyChooseheading: "Commercial Distribution Support",
            WhyChoosedescription: "Commercial businesses often manage recurring cargo movement between suppliers, warehouses, distributors, and customer markets. SSK Logistic provides road transportation support for these distribution requirements with practical scheduling and route coordination."
        },
        {
            WhyChooseheading: "Interstate Route Connectivity",
            WhyChoosedescription: "Cargo requirements frequently extend beyond Pune into Maharashtra and other parts of India. SSK Logistic supports interstate road transportation for businesses connecting Pune operations with northern, southern, eastern, and western destination markets."
        },
        {
            WhyChooseheading: "FTL and Large Consignment Support",
            WhyChoosedescription: "Businesses moving substantial quantities of goods may require dedicated vehicle capacity instead of shared transportation. SSK Logistic supports full truck load and larger cargo requirements with transportation planning based on shipment volume and route distance."
        },
        {
            WhyChooseheading: "Specialized Cargo Coordination",
            WhyChoosedescription: "Certain consignments require additional planning because of their weight, dimensions, value, or handling requirements. SSK Logistic assists with specialized cargo transportation requirements including ODC, heavy cargo, containerized loads, and other non-standard shipments."
        },
        {
            WhyChooseheading: "Flexible Pickup and Delivery Planning",
            WhyChoosedescription: "Cargo movement can involve factories, warehouses, distribution centers, commercial premises, and project locations. SSK Logistic coordinates transportation around different pickup and delivery points while adapting the movement plan to the operational requirements of the business."
        },
        {
            WhyChooseheading: "Pune-Based Logistics Coordination",
            WhyChoosedescription: "Pune's industrial and commercial network generates cargo movement across both local and long-distance routes. SSK Logistic provides transportation coordination for businesses that need their cargo connected with regional suppliers, national markets, warehouses, and distribution destinations."
        }
    ]

};








const faqData = [
    {
        question: "What cargo transportation services does SSK Logistic provide in Pune?",
        answer: "SSK Logistic assists businesses with cargo transportation from Pune for commercial, industrial, and business consignments, with suitable transportation arrangements based on cargo specifications, route, vehicle capacity, and delivery requirements."
    },
    {
        question: "Can SSK Logistic transport cargo from Pune to other cities?",
        answer: "Cargo movement can be coordinated from Pune to destinations such as Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, and other locations across Maharashtra and India."
    },
    {
        question: "What types of cargo can be transported through SSK Logistic?",
        answer: "Suitable cargo may include industrial materials, machinery, equipment, commercial inventory, packaged goods, raw materials, finished products, supplies, and other business consignments according to their size, weight, and handling requirements."
    },
    {
        question: "Does SSK Logistic handle regular cargo transportation requirements?",
        answer: "Businesses with recurring cargo movement can discuss regular transportation arrangements based on their shipment frequency, preferred routes, cargo volume, vehicle requirements, pickup schedules, and delivery timelines."
    },
    {
        question: "How does SSK Logistic determine the appropriate cargo vehicle?",
        answer: "Vehicle planning takes into consideration the cargo weight, dimensions, quantity, volume, loading conditions, material type, route distance, destination, and other practical transportation requirements."
    },
    {
        question: "Can SSK Logistic arrange cargo transportation from Pune to Mumbai?",
        answer: "Yes, Pune to Mumbai cargo transportation can be arranged for commercial stock, industrial supplies, machinery, equipment, packaged products, business materials, and other suitable consignments."
    },
    {
        question: "Does SSK Logistic provide interstate cargo transportation from Pune?",
        answer: "Interstate cargo movement can be coordinated from Pune toward Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other destinations depending on the shipment and route requirements."
    },
    {
        question: "Can industrial companies use SSK Logistic for cargo movement?",
        answer: "Manufacturers, suppliers, distributors, warehouses, and industrial businesses can use cargo transportation support for moving raw materials, finished goods, machinery, equipment, commercial stock, and other business-related shipments."
    },
    {
        question: "Can cargo transportation be customized for different shipment requirements?",
        answer: "Yes, transportation planning can be adjusted according to the pickup point, delivery destination, cargo characteristics, quantity, weight, dimensions, loading requirements, vehicle capacity, and required delivery schedule."
    },
    {
        question: "What details should I provide for a cargo transportation enquiry in Pune?",
        answer: "To discuss the cargo movement, provide the pickup location, destination, cargo type, approximate weight or quantity, dimensions if applicable, loading details, vehicle preference, and expected delivery timeframe."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Tejas Chitale",
        feedback: "We needed to transport commercial cargo from Pune to Bhopal, and SSK Logistic coordinated the movement according to our shipment details. The vehicle requirement and route information were handled clearly.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Pallavi Shirole",
        feedback: "Our business required transportation for industrial cargo from Pune to Mumbai. SSK Logistic understood the material and quantity details and helped arrange the transportation in an organized manner.",
        rating: 5
    }
];













    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cargo Transportation Company in Pune",
  "image": "https://ssklogistics.in/assets/images/cargo-transportation-company-in-pune.webp",
  "description": "SSK Logistics provides Cargo Transportation Company in Pune solutions for businesses requiring organized movement of commercial, industrial and specialized cargo across local, regional and interstate routes. Cargo transportation company Pune requirements can include shipment planning, vehicle coordination, route management and transportation support for different types of consignments. Cargo transport company Pune services can assist manufacturers, distributors, wholesalers, retailers and industrial businesses with regular or project-based cargo movement. Cargo transportation services Pune and cargo transport services Pune can cover commercial shipments, industrial materials, packaged goods, machinery, equipment and other business consignments. Cargo transporters Pune requirements can be supported through suitable vehicle arrangements based on cargo volume, dimensions, weight and destination, while a cargo logistics company Pune can coordinate transportation as part of wider logistics operations. Cargo logistics services Pune may include freight movement, warehouse transfers, supplier transportation and distribution support. Freight cargo transportation Pune can be arranged for regional and interstate business routes, while industrial cargo transport Pune and commercial cargo transportation Pune are suited to manufacturing materials, commercial products and business shipments. Heavy cargo transport Pune requirements may involve large or high-weight consignments, while high value cargo transportation Pune can be planned with appropriate handling and transportation coordination. Container cargo transport Pune supports containerized shipments, and road cargo transportation Pune provides practical movement between warehouses, factories, suppliers and customer destinations. Full truck load cargo transport Pune can be used for dedicated vehicle requirements where a complete vehicle is assigned to a shipment. ODC transportation Pune requirements can include oversized or dimensionally difficult cargo that needs careful vehicle selection, route planning and movement coordination. SSK Logistics focuses on flexible cargo transportation arrangements designed around the specific requirements of businesses operating from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/cargo-transportation-company-in-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>
    Cargo Transportation Company in Pune | Industrial, Commercial, Heavy & ODC Cargo Transport | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics offers cargo transportation services in Pune for industrial, commercial, heavy, container, FTL, high-value and ODC cargo with coordinated road transportation solutions."
  />

  <meta
    name="keywords"
    content="Cargo Transportation Company in Pune, cargo transportation company Pune, cargo transport company Pune, cargo transportation services Pune, cargo transport services Pune, cargo transporters Pune, cargo logistics company Pune, cargo logistics services Pune, freight cargo transportation Pune, industrial cargo transport Pune, commercial cargo transportation Pune, heavy cargo transport Pune, high value cargo transportation Pune, container cargo transport Pune, road cargo transportation Pune, full truck load cargo transport Pune, ODC cargo transportation Pune, ODC transport Pune, ODC cargo transport Pune, oversized cargo transportation Pune, over dimensional cargo transport Pune, heavy cargo transportation Pune, industrial cargo transportation Pune, commercial cargo transport Pune, freight transportation Pune, freight cargo services Pune, cargo logistics Pune, cargo transportation company in Pune, cargo transport services in Pune, cargo transporter in Pune, cargo delivery services Pune, business cargo transportation Pune, B2B cargo transport Pune, warehouse cargo transportation Pune, factory cargo transport Pune, machinery cargo transportation Pune, equipment cargo transport Pune, container transportation Pune, FTL cargo transportation Pune, dedicated truck cargo transport Pune, interstate cargo transportation Pune, Maharashtra cargo transportation Pune, specialized cargo transportation Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cargotransportationcompmany;